export const SETTING_HEADER_PREFIX = "X-IF-MIDDLEWARE-SETTING";

export const buildSettingHeaderKey = (key: string) =>
  `${SETTING_HEADER_PREFIX}-${key.replaceAll("_", "-")}`;

export const formatMiddlewareHeadersForS2S = (_headers: Headers) => {
  const headers = new Headers(_headers);
  headers.delete("host");
  headers.delete("transfer-encoding");
  headers.delete("content-type");
  return headers;
};
